import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Megaphone, Save, Loader2 } from 'lucide-react';
import { AdminPageHeader, API } from './_P1Common';
import { useAdmin } from '@/hooks/useAdmin';

const FIELDS = [
  { key: 'client_id', label: 'AdSense Client ID (ca-pub-…)' },
  { key: 'slot_top', label: 'Gornji slot (slot ID)' },
  { key: 'slot_sidebar', label: 'Bočni slot' },
  { key: 'slot_inline', label: 'Inline slot' },
];

export default function AdminAdsense() {
  const { authFetch } = useAdmin();
  const [data, setData] = useState(null);

  useEffect(() => {
    authFetch(`${API}/admin/adsense`).then(r => r.json()).then(setData);
  }, [authFetch]);

  const save = async () => {
    const r = await authFetch(`${API}/admin/adsense`, {
      method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data),
    });
    if (r.ok) toast.success('Spremljeno');
  };

  if (!data) return <AdminPageHeader icon={Megaphone} title="AdSense"><Loader2 className="animate-spin"/></AdminPageHeader>;

  return (
    <div data-testid="admin-adsense">
      <AdminPageHeader icon={Megaphone} title="AdSense" subtitle="Postavke za Google AdSense oglase">
        <button onClick={save} data-testid="adsense-save"
                className="inline-flex items-center gap-1 px-3 py-2 rounded bg-red-600 hover:bg-red-700 text-white text-sm font-bold">
          <Save size={14}/> Spremi
        </button>
      </AdminPageHeader>
      <div className="px-4 md:px-6 pb-6 max-w-xl space-y-3">
        <label className="flex items-center gap-2 text-sm py-2 border-b border-zinc-800">
          <input type="checkbox" checked={!!data.enabled} data-testid="adsense-enabled"
                 onChange={(e) => setData({ ...data, enabled: e.target.checked })}/>
          AdSense aktivan
        </label>
        {FIELDS.map(f => (
          <div key={f.key}>
            <label className="text-xs uppercase text-zinc-500 block mb-1">{f.label}</label>
            <input value={data[f.key] ?? ''} data-testid={`adsense-${f.key}`}
                   onChange={(e) => setData({ ...data, [f.key]: e.target.value })}
                   className="w-full bg-zinc-950 border border-zinc-800 rounded px-3 py-2 text-sm"/>
          </div>
        ))}
      </div>
    </div>
  );
}
